import { apiClient } from './apiClient';

export interface UpdateMePayload {
  name?: string | undefined;
  role?: 'admin' | 'viewer' | undefined;
}

export async function getMe() {
  return apiClient.get<{ id: string; email: string; name?: string; role: string; avatarUrl?: string }>(`/users/me`);
}

export async function updateMe(payload: UpdateMePayload) {
  return apiClient.patch<{ id: string; email: string; name?: string; role: string; avatarUrl?: string }>(`/users/me`, payload);
}

export async function uploadAvatar(file: File) {
  const form = new FormData();
  form.append('avatar', file);
  const res = await fetch(`/users/me/avatar`, { method: 'POST', body: form, credentials: 'include' });
  if (!res.ok) throw new Error(`upload_failed:${res.status}`);
  return res.json() as Promise<{ avatarUrl: string }>;
}
